export const LAYOUT_MAX_WIDTH = 2400;
